import {CommonModule} from '@angular/common';
import {Component, HostBinding, HostListener, Input, OnDestroy, OnInit} from '@angular/core';
import {BackButtonComponent} from '../back-button/back-button.component';
import {LangService} from '../../../core/services/lang.service';

@Component({
  selector: 'info-page-header',
  templateUrl: './info-page-header.component.html',
  styleUrls: ['./info-page-header.component.scss'],
  imports: [
    BackButtonComponent,
    CommonModule
  ],
  standalone: true
})
export class InfoPageHeaderComponent implements OnInit, OnDestroy {
  @Input() label = '';
  @Input() navigateTo?: string;

  private _sublabel?: string;
  public translatedSublabel = '';

  @Input()
  set sublabel(value: string | undefined) {
    this._sublabel = value;
    if (value) {
      this.langService.translateText(value).then(translated => {
        this.translatedSublabel = translated;
        console.log(translated);
      });
    } else {
      this.translatedSublabel = '';
    }
  }

  get sublabel(): string | undefined {
    return this._sublabel;
  }

  @HostBinding('style.--header-height.px')
  headerHeight = 112;

  constructor(private langService: LangService) {}

  @HostBinding('style.--header-title-size.px')
  titleSize = 31;

  @HostBinding('style.--header-subtitle-size.px')
  subtitleSize = 20;

  private readonly maxHeaderHeight = 112;
  private readonly minHeaderHeight = 56;
  private readonly maxTitleSize = 31;
  private readonly minTitleSize = 20;
  private readonly maxSubtitleSize = 20;
  private readonly minSubtitleSize = 13;
  private readonly scrollDistance = 120;

  private animationFrameId: number | null = null;

  ngOnInit(): void {
    this.updateHeaderSize();
  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    if (this.animationFrameId !== null) {
      return;
    }

    this.animationFrameId = window.requestAnimationFrame(() => {
      this.updateHeaderSize();
      this.animationFrameId = null;
    });
  }

  ngOnDestroy(): void {
    if (this.animationFrameId !== null) {
      window.cancelAnimationFrame(this.animationFrameId);
    }

    document.documentElement.style.removeProperty('--info-page-header-height');
  }

  private updateHeaderSize(): void {
    const progress = Math.min(window.scrollY / this.scrollDistance, 1);

    this.headerHeight = this.interpolate(this.maxHeaderHeight, this.minHeaderHeight, progress);
    this.titleSize = this.interpolate(this.maxTitleSize, this.minTitleSize, progress);
    this.subtitleSize = this.interpolate(this.maxSubtitleSize, this.minSubtitleSize, progress);

    document.documentElement.style.setProperty('--info-page-header-height', `${this.headerHeight}px`);
  }

  private interpolate(max: number, min: number, progress: number): number {
    return max - (max - min) * progress;
  }
}
